import React, { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Chip,
  CircularProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// Iconos de estadísticas removidos
import { trackPromise } from 'react-promise-tracker';
import Alert from '../../components/Alert';
import ConsultaPlazasService from '../../services/ConsultaPlazasService';
import PlazasPorCarreraUniversidad from './components/PlazasPorCarreraUniversidad';
import ServiciosConPlazas from './components/ServiciosConPlazas';
// import EstadisticasGenerales from './components/EstadisticasGenerales'; // Removido
import DetallePlazas from './components/DetallePlazas';
import FiltrosSimples from './components/FiltrosSimples';
import NotificacionesPanel from './components/NotificacionesPanel';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    backgroundColor: '#f5f5f5',
  },
  filterContent: {
    padding: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
    marginRight: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  // Estilos de estadísticas removidos
  tabContainer: {
    marginTop: theme.spacing(3),
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
  },
}));

const ConsultaPlazasMain = () => {
  const classes = useStyles();
  
  // Estados
  const [activeView, setActiveView] = useState('resumen');
  const [carreras, setCarreras] = useState([]);
  const [universidades, setUniversidades] = useState([]);
  const [selectedCarrera, setSelectedCarrera] = useState('');
  const [selectedUniversidad, setSelectedUniversidad] = useState('');
  const [loading, setLoading] = useState(false);
  const [estadisticas, setEstadisticas] = useState(null);
  const [datosParaNotificaciones, setDatosParaNotificaciones] = useState([]);
  const [filtrosActivos, setFiltrosActivos] = useState({});

  // Cargar datos iniciales
  useEffect(() => {
    loadInitialData();
  }, []);

  // NUEVO: Recalcular estadísticas cuando cambian los filtros
  useEffect(() => {
    if (Object.keys(filtrosActivos).some(key => filtrosActivos[key])) {
      console.log('🔄 PASO 15: Recalculando estadísticas con filtros:', filtrosActivos);
      // Aquí deberíamos recalcular las estadísticas, pero por ahora solo logueamos
      console.log('⚠️ PROBLEMA IDENTIFICADO: Las estadísticas no se recalculan con filtros');
    }
  }, [filtrosActivos]);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      // Intentar cargar datos con manejo de errores individual
      let carrerasData = [];
      let universidadesData = [];
      let estadisticasData = null;
      let datosNotificaciones = [];

      try {
        carrerasData = await trackPromise(ConsultaPlazasService.getCarreras());
      } catch (error) {
        console.warn('Error al cargar carreras, usando datos mock:', error);
        carrerasData = [
          { id: 1, descripcion: 'Medicina' },
          { id: 2, descripcion: 'Enfermería' },
          { id: 3, descripcion: 'Odontología' }
        ];
      }

      try {
        universidadesData = await trackPromise(ConsultaPlazasService.getUniversidades());
      } catch (error) {
        console.warn('Error al cargar universidades, usando datos mock:', error);
        universidadesData = [
          { id: 1, institucion: 'Universidad Nacional de Asunción' },
          { id: 2, institucion: 'Universidad Católica' },
          { id: 3, institucion: 'Universidad del Norte' }
        ];
      }

      // Estadísticas removidas - solo usamos la tabla principal
      estadisticasData = {
        totales: {},
        distribucionPorCarrera: [],
        distribucionPorUniversidad: [],
        distribucionPorRegion: []
      };

      try {
        datosNotificaciones = await trackPromise(
          ConsultaPlazasService.getPlazasPorCarreraUniversidad()
        );
      } catch (error) {
        console.warn('Error al cargar datos para notificaciones:', error);
        datosNotificaciones = [];
      }

      setCarreras(carrerasData);
      setUniversidades(universidadesData);
      setEstadisticas(estadisticasData);
      setDatosParaNotificaciones(datosNotificaciones);

    } catch (error) {
      console.error('Error general al cargar datos iniciales:', error);
      Alert.show({
        message: "Error al cargar datos. Algunos datos pueden no estar disponibles.",
        type: "warning",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleViewChange = (view) => {
    setActiveView(view);
  };

  const handleCarreraChange = (value) => {
    console.log('Carrera seleccionada:', value);
    setSelectedCarrera(value || '');
  };

  const handleUniversidadChange = (value) => {
    console.log('Universidad seleccionada:', value);
    setSelectedUniversidad(value || '');
  };

  const clearFilters = () => {
    setSelectedCarrera('');
    setSelectedUniversidad('');
    setFiltrosActivos({});
  };

  const handleFiltrosChange = (filtros) => {
    setFiltrosActivos(filtros);
  };

  const handleRefreshNotifications = useCallback(() => {
    loadInitialData();
  }, []);

  // Función de estadísticas removida - ya no se muestran las tarjetas de estadísticas

  const renderFilters = () => (
    <FiltrosSimples
      selectedCarrera={selectedCarrera}
      selectedUniversidad={selectedUniversidad}
      onCarreraChange={handleCarreraChange}
      onUniversidadChange={handleUniversidadChange}
      onFiltrosChange={handleFiltrosChange}
      filtrosActivos={filtrosActivos}
    />
  );

  const renderViewButtons = () => (
    <Box mb={3}>
      <Button
        variant={activeView === 'resumen' ? 'contained' : 'outlined'}
        color="primary"
        onClick={() => handleViewChange('resumen')}
        className={classes.button}
      >
        Resumen General
      </Button>
      <Button
        variant={activeView === 'servicios' ? 'contained' : 'outlined'}
        color="primary"
        onClick={() => handleViewChange('servicios')}
        className={classes.button}
      >
        Servicios de Salud
      </Button>
      {selectedCarrera && selectedUniversidad && (
        <Button
          variant={activeView === 'detalle' ? 'contained' : 'outlined'}
          color="secondary"
          onClick={() => handleViewChange('detalle')}
          className={classes.button}
        >
          Ver Detalle
        </Button>
      )}
    </Box>
  );

  const renderActiveView = () => {
    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    switch (activeView) {
      case 'resumen':
        return (
          <div>
            <PlazasPorCarreraUniversidad
              key={`tabla-${JSON.stringify(filtrosActivos)}-${selectedCarrera}-${selectedUniversidad}`}
              selectedCarrera={selectedCarrera}
              selectedUniversidad={selectedUniversidad}
              filtrosActivos={filtrosActivos}
            />
          </div>
        );
      case 'servicios':
        return <ServiciosConPlazas filtrosActivos={filtrosActivos} />;
      case 'detalle':
        return (
          <DetallePlazas
            carreraId={selectedCarrera}
            universidadId={selectedUniversidad}
            filtrosActivos={filtrosActivos}
          />
        );
      default:
        return (
          <PlazasPorCarreraUniversidad
            key={`tabla-default-${JSON.stringify(filtrosActivos)}`}
            selectedCarrera={selectedCarrera}
            selectedUniversidad={selectedUniversidad}
            filtrosActivos={filtrosActivos}
          />
        );
    }
  };

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Paper className={classes.paper}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" className={classes.title}>
            Gestión de Plazas por Universidad y Servicio
          </Typography>
          {(Object.keys(filtrosActivos).some(key => filtrosActivos[key]) || selectedCarrera || selectedUniversidad) && (
            <Chip
              label={`Filtros activos: ${
                [
                  selectedCarrera ? 'Carrera' : '',
                  selectedUniversidad ? 'Universidad' : '',
                  filtrosActivos.region ? 'Región' : '',
                  filtrosActivos.nivelServicio ? 'Nivel' : '',
                  filtrosActivos.estadoConfirmacion ? 'Estado' : ''
                ].filter(Boolean).length
              }`}
              color="primary"
              variant="outlined"
            />
          )}
        </Box>


        <NotificacionesPanel
          data={datosParaNotificaciones}
          onRefresh={handleRefreshNotifications}
        />

        {renderViewButtons()}
        
        <div className={classes.tabContainer}>
          {renderActiveView()}
        </div>
      </Paper>
    </Container>
  );
};

export default ConsultaPlazasMain;
